import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {Tab} from '../../../tabbing/data/tab';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {FlagEditorTooltip} from '../../data/flagEditorTooltip';
import {Router} from '@angular/router';
import {FlagService} from '../../services/flag.service';
import {FlagColor} from '../../data/flagColor';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'app-popup-flag-editor',
  templateUrl: './popup-flag-editor.component.html',
  styleUrls: ['./popup-flag-editor.component.scss']
})
export class PopupFlagEditorComponent implements OnInit, AfterViewInit {

  @Input() tab: Tab;
  @Input() tooltip: FlagEditorTooltip;
  positionStyle: SafeStyle;

  constructor(public domSanitizer: DomSanitizer,
              public flagService: FlagService,
              public router: Router,
              private loggingService: LoggerService) {
    this.domSanitizer = domSanitizer;
    this.flagService = flagService;
    this.router = router;
  }

  ngOnInit(): void {
  }


  ngAfterViewInit(): void {
    setInterval(() => {
      const rect = this.tooltip.ref.nativeElement.getBoundingClientRect();
      const style = 'position:fixed;' +
        'top:' + (rect.top) + 'px;' +
        'left:' + (rect.left - 300) + 'px;';
      this.positionStyle = this.domSanitizer.bypassSecurityTrustStyle(style);
    }, 500);
  }

  setColor(color: FlagColor) {
    this.tooltip.flaggableObject.flagColor = color;
    this.tooltip.flaggableObject.flagged = true;
    this.selectFlag(true, color);
    this.tooltip.life = -1;
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.PopupFlagEditor, 'Color set: ' + FlagColor[color]);
  }

  removeFlag() {
    this.tooltip.flaggableObject.flagged = false;
    this.selectFlag(false, FlagColor.Red);
    this.tooltip.life = -1;
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.PopupFlagEditor, 'Removed flag.');
  }

  selectFlag(flagged: boolean, flagColor: FlagColor) {
    this.tooltip.onFlagSelect.emit({flagged, flagColor});
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.PopupFlagEditor, 'Flag selected');
  }
}
